<template>
  <tr v-bind:class="{'row-has-errors' : lengthErrors.length > 0 || diameterErrors.length > 0}">
    <td>{{ index + 1 }}</td>
    <td id="input-log-number">
      <input type="text" class="input" min="0" v-model="row.logNumber" />
    </td>
    <td id="input-wood-type">
      <div class="select">
        <select v-model="row.woodType">
          <option>Fichte</option>
          <option>Tanne</option>
          <option>Douglasie</option>
          <option>Kiefer</option>
          <option>Lärche</option>
        </select>
      </div>
    </td>
    <td>
      <span v-bind="lengthErrors.length > 0 ? balloonLength : '' ">
        <input
          v-bind:class="{'is-danger' : lengthErrors.length > 0}"
          v-model.number="row.length"
          class="input"
          type="number"
          min="3"
          placeholder="Länge"
          v-on:input="checkLengthInput"
        />
      </span>
    </td>
    <td>
      <span v-bind="diameterErrors.length > 0 ? balloonDiameter : '' ">
        <input
          v-bind:class="{'is-danger' : diameterErrors.length > 0}"
          v-model.number="row.diameter"
          class="input"
          type="number"
          min="10"
          step="1"
          placeholder="Ø"
          v-on:input="checkDiameterInput"
        />
      </span>
    </td>
    <td v-if="measuredWithBark" id="input-diameter-without-bark">
      <input v-model="calculatedDiameterWithoutBark" class="input" disabled placeholder="Ø" />
    </td>
    <td id="input-strength-class">
      <input v-model="calculatedStrengthClass" class="input" disabled />
    </td>
    <td>
      <div class="select">
        <select tabindex="0" v-model="row.quality" id="input-quality">
          <option>B</option>
          <option>B/C</option>
          <option>C</option>
          <option>CK</option>
          <option>C/G</option>
          <option>D</option>
        </select>
      </div>
    </td>
    <td id="input-volume">
      <input v-model="row.volume" class="input" disabled />
    </td>
    <td>
      <input v-model="row.note" class="input" type="text" placeholder="Bemerkungen" />
    </td>
    <td id="remove-row-button">
      <a
        class="button"
        id="removeButton"
        tabindex="0"
        v-on:click="$emit('remove-row',index)"
        v-on:keyup.enter="$emit('remove-row',index)"
      >
        <span class="icon is-small">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path d="M 5 15 L 5 17 L 27 17 L 27 15 L 5 15 z" />
          </svg>
        </span>
      </a>
    </td>
    <td>
      <a
        v-on:click="$emit('add-row',index)"
        v-on:keyup.enter="$emit('add-row',index)"
        class="button"
        id="addButton"
        tabindex="0"
      >
        <span class="icon is-small">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path
              d="M 15 5 L 15 15 L 5 15 L 5 17 L 15 17 L 15 27 L 17 27 L 17 17 L 27 17 L 27 15 L 17 15 L 17 5 L 15 5 z"
            />
          </svg>
        </span>
      </a>
    </td>
  </tr>
</template>

<script>
import helperMixin from "../mixins/helper-mixin.js";

export default {
  name: "timber-table-row",
  mixins: [helperMixin],
  props: {
    measuredWithBark: Boolean,
    index: Number,
    row: {
      id: Number, // TODO: should be calculated
      logNumber: String, // TODO: should also be calculated
      woodType: String,
      length: Number,
      diameter: Number,
      diamterWithoutBark: Number,
      strengthClass: String, // calculated
      quality: String,
      volume: String,
      note: String
    }
  },
  data() {
    return {
      balloonLength: {
        "data-balloon-visible": true,
        "aria-label": "Gültige Länge angeben",
        "data-balloon-pos": "up"
      },
      balloonDiameter: {
        "data-balloon-visible": true,
        "aria-label": "Gültigen Durchmesser angeben",
        "data-balloon-pos": "right"
      },
      lengthErrors: [],
      diameterErrors: []
    };
  },
  methods: {
    checkLengthInput() {
      this.lengthErrors = [];
      if (typeof this.row.length !== "number" || this.row.length <= 3) {
        this.lengthErrors.push("Bitte Länge in Meter angeben");
      }
    },
    checkDiameterInput() {
      this.diameterErrors = [];
      if (typeof this.row.diameter !== "number" || this.row.diameter <= 10) {
        this.diameterErrors.push("Bitte Durchmesser in cm angeben");
      }
    },
    checkLogNumberInput() {
      this.logNumberErrors = [];
      if (this.row.logNumber === "" || this.row.logNumber.trim() === "") {
        this.logNumberErrors.push(
          "Bitte eindeutige Nummer für den Stamm angeben"
        );
      }
    }
  },
  computed: {
    // Calculates the new value of the wood diameter without bark
    // according to the specification from http://www.rvr-deutschland.de/
    // https://mlr.baden-wuerttemberg.de/fileadmin/redaktion/m-mlr/intern/dateien/publikationen/ForstBW_Sortiermerkblaetter.pdf
    calculatedDiameterWithoutBark: function() {
      if (!this.measuredWithBark) {
        return this.row.diameter;
      } else {
        var barkDiscount = 0;
        var diameterWithBark = this.row.diameter;

        if (this.row.diameter <= 0 || typeof this.row.diameter !== "number") {
          return 0;
        }
        switch (this.row.woodType) {
          case "Fichte":
            if (diameterWithBark <= 26) {
              barkDiscount = 1;
            } else if (diameterWithBark <= 50) {
              barkDiscount = 2;
            } else {
              barkDiscount = 3;
            }
            break;
          case "Douglasie":
            if (diameterWithBark <= 20) {
              barkDiscount = 1;
            } else if (diameterWithBark <= 37) {
              barkDiscount = 2;
            } else if (diameterWithBark <= 53) {
              barkDiscount = 3;
            } else if (diameterWithBark <= 70) {
              barkDiscount = 4;
            } else {
              barkDiscount = 5;
            }
            break;
          case "Tanne":
            if (diameterWithBark <= 22) {
              barkDiscount = 1;
            } else if (diameterWithBark <= 38) {
              barkDiscount = 2;
            } else if (diameterWithBark <= 55) {
              barkDiscount = 3;
            } else {
              barkDiscount = 4;
            }
            break;
          case "Kiefer":
            if (diameterWithBark <= 20) {
              barkDiscount = 1;
            } else if (diameterWithBark <= 36) {
              barkDiscount = 2;
            } else if (diameterWithBark <= 62) {
              barkDiscount = 3;
            } else {
              barkDiscount = 4;
            }
            break;
          case "Lärche":
            if (diameterWithBark <= 20) {
              barkDiscount = 1;
            } else if (diameterWithBark <= 31) {
              barkDiscount = 2;
            } else if (diameterWithBark <= 42) {
              barkDiscount = 3;
            } else if (diameterWithBark <= 53) {
              barkDiscount = 4;
            } else {
              barkDiscount = 5;
            }
            break;
        }

        return diameterWithBark - barkDiscount;
      }
    },
    calculatedVolume: function() {
      var diameter = this.measuredWithBark
        ? this.calculatedDiameterWithoutBark
        : this.row.diameter;
      var pi = Math.PI;
      // V = pi ⁄ 4 × d² × L × 10{–4}
      var volume =
        (pi / 4) *
        Math.pow(Number(diameter), 2) *
        Number(this.row.length) *
        Math.pow(10, -4);
      if (volume > 0) {
        return volume
      } else {
        return 0;
      }
    },
    calculatedStrengthClass: function() {
      var strengthClass = "";
      var diameter = this.measuredWithBark
        ? this.calculatedDiameterWithoutBark
        : this.row.diameter;

      if (diameter <= 9) {
        strengthClass = "0";
      } else if (diameter <= 14) {
        strengthClass = "1a";
      } else if (diameter <= 19) {
        strengthClass = "1b";
      } else if (diameter <= 24) {
        strengthClass = "2a";
      } else if (diameter <= 29) {
        strengthClass = "2b";
      } else if (diameter <= 34) {
        strengthClass = "3a";
      } else if (diameter <= 39) {
        strengthClass = "3b";
      } else if (diameter <= 44) {
        strengthClass = "4a";
      } else if (diameter <= 49) {
        strengthClass = "4b";
      } else if (diameter <= 59) {
        strengthClass = "5";
      } else if (diameter >= 60) {
        strengthClass = "6";
      } else {
        return 0; // default
      }
      return strengthClass;
    }
  },
  watch: {
    calculatedVolume: function(newValue) {
      this.row.volume = this.round(newValue);
    },
    calculatedStrengthClass: function(newValue) {
      this.row.strengthClass = newValue;
    },
    calculatedDiameterWithoutBark: function(newValue) {
      this.row.diameterWithoutBark = newValue;
    }
  }
};
</script>

<style scoped>
#input-log-number {
  width: 7em;
}
#input-wood-type {
  width: 6em;
}
#input-diameter-without-bark {
  width: 8em;
}
#input-strength-class {
  width: 2em;
}
#input-quality {
  width: 5em;
}
#input-volume {
  width: 8em;
}
#remove-row-button {
  padding-right: 0em;
}

.row-has-errors {
  background-color: rgb(255, 228, 234);
  transition: background-color 200ms ease-in-out;
}
.table.is-hoverable.is-striped tbody tr.row-has-errors:not(.is-selected):hover {
  background-color: rgb(255, 197, 210);
}
</style>